<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="20"
              class="left">
        <el-tree :default-expand-all="true"
                 :expand-on-click-node="false"
                 :data="treeData"
                 :props="defaultProps"
                 :check-strictly="true"
                 node-key="id"
                 show-checkbox
                 @check-change="handleCheckChange"
                 ref="tree">
        </el-tree>
      </el-col>
    </el-row>
  </div>
</template>
<script>

    export default {
        data() {
            return {
                checkedAllTree: false,
                treeData: [],
                defaultProps: {
                    children: 'childEntity',
                    label: 'entityName'
                },
            }
        },
        methods: {
            handleCheckChange(data) {
                this.onChangeFun(this.$refs.tree.getCheckedKeys())
            },
            onConfirm() {
                this.onOrgFun(this.$refs.tree.getCheckedKeys())
            }
        },
        watch: {
            initData: {
                handler: function (val, oldval) {
                    if (val) {
                        this.treeData = val
                    }
                }
            }
        },
        props: {
            initData: [String, Object, Array],
            onOrgFun: {
                type: Function,
                default: () => {
                }
            },
            onChangeFun: {
                type: Function,
                default: () => {
                }
            }
        }
    }
</script>
<style scoped>
  .left {
    height: 240px;
    margin-left: 10px;
    overflow-y: auto;
  }

  .node-ruleForm {
    border: 1PX solid #dcdfe6;
    height: 280px;
    padding: 45px 0 0 45px;
  }

  .form-cel {
    padding: 20px 50px 0 0;
  }

  .btn-right {
    text-align: right;
    padding-right: 60px;
  }
</style>
